import { Flex } from "@chakra-ui/layout";
import { useMemo } from "react";
import { EquipamentoDto } from "features/equipamento/typings";
import moment from "moment";

function useEquipamentosColumns() {
  return useMemo(() => {
    return [
      {
        title: "Nome do patrimônio",
        width: "200px",
        render: (original: EquipamentoDto) => <Flex>{original.nome}</Flex>,
      },
      {
        title: "Data de compra",
        width: "150px",
        render: (original: EquipamentoDto) => (
          <Flex>
            {original.dataCompra
              ? moment(original.dataCompra).format("DD/MM/YYYY")
              : "--"}
          </Flex>
        ),
      },
      {
        title: "Marca",
        width: "150px",
        render: (original: EquipamentoDto) => (
          <Flex>{original.marca?.nome ? original.marca.nome : "--"}</Flex>
        ),
      },
      {
        title: "Local",
        width: "250px",
        render: (original: EquipamentoDto) => <Flex>{original.local}</Flex>,
      },
      {
        title: "Observação",
        render: (original: EquipamentoDto) => (
          <Flex>{original.observacao}</Flex>
        ),
      },
    ];
  }, []);
}

export default useEquipamentosColumns;
